export default {
  title: 'Päivitykset',
  fields: {
    app_version: 'Sovellusversio',
    description: 'Kuvaus',
    created_at: 'Luotu',
  },
};
